import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { InputControl } from "../InputControl/InputControl.js";
import "../InputControl/Input/InputBase.js";
import { SearchIcon } from "../../icons/24/System/Search.js";
import { spreadSx } from "../../utils/spreadSx.js";
import { useDelay } from "./useDelay.js";
import { styles } from "./styles.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
const SearchControl = memo(
  ({ className, delay = 0, sx, ...restProps }) => {
    const { name, value, onChange } = restProps, { internalValue, handleChange } = useDelay({
      delay,
      name,
      value,
      onChange
    });
    return /* @__PURE__ */ jsx(
      InputControl,
      {
        className,
        type: "text",
        sx: [styles.searchStyleAdjustments, ...spreadSx(sx)],
        "data-test-id": DATA_TEST_ID_INHERITED,
        ...restProps,
        value: internalValue,
        onChange: handleChange,
        startAdornment: /* @__PURE__ */ jsx(SearchIcon, { size: 18 })
      }
    );
  }
);
SearchControl.displayName = "SearchControl";
export {
  SearchControl
};
//# sourceMappingURL=SearchControl.js.map
